// extracted by mini-css-extract-plugin
export var container = "intro-module--container--Kp6fb";
export var content = "intro-module--content--KpqLx";
export var subHeading = "intro-module--sub-heading--QzGK6";
export var title = "intro-module--title--XyWVw";